import { TextAlignStartIcon, UsersIcon } from "lucide-react";

import { UserProfileFragment } from "@/__generated__/graphql";
import { ObjectType } from "@/objects/@types";

const object: ObjectType<UserProfileFragment> = {
  humanName: "user-profile",
  typename: "UserProfileObject",
  ReactIcon: UsersIcon,
  isEntity: true,
  // The whole name, edited as the page's title; saved, it is split into the
  // first and last names below, where a split that comes out wrong is fixed.
  titleFieldKey: "name",
  getTitle: (data) => {
    // The person's own name, as they have written it; until they have, what the page is.
    return data?.name || "Profile";
  },
  getEntityId: (data) => {
    return data?.entity?.id;
  },
  fieldDefinitions: [
    {
      objectKey: "name",
      label: "Name",
      type: "text",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.name,
      getValue: (data) => {
        return data?.name;
      },
      getValueOptions: () => ({
        placeholder: "Your name",
      }),
      updateProps: {
        isRequired: false,
        isEditable: true,
      },
      summaryProps: {
        isVisible: true,
      },
      fieldProps: {
        headerFieldType: "string",
      },
    },
    {
      objectKey: "firstName",
      label: "First Name",
      type: "text",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.firstName,
      getValue: (data) => {
        return data?.firstName;
      },
      getValueOptions: () => ({
        placeholder: "John, etc.",
      }),
      updateProps: {
        isRequired: false,
        isEditable: true,
      },
      summaryProps: {
        isVisible: true,
      },
      fieldProps: {
        headerFieldType: "string",
      },
    },
    {
      objectKey: "lastName",
      label: "Last Name",
      type: "text",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.lastName,
      getValue: (data) => {
        return data?.lastName;
      },
      getValueOptions: () => ({
        placeholder: "Doe, etc.",
      }),
      updateProps: {
        isRequired: false,
        isEditable: true,
      },
      summaryProps: {
        isVisible: true,
      },
    },
  ],
};

export { object as UserProfileObject };
